export default {
  home: {
    matchups: {
      today: "Today's Matchups",
      thisWeek: "This Week's Matchups",
      upcoming: "Upcoming Matchups",
    },
    actions: {
      showMore: "Show more",
      showLess: "Show less",
    },
    empty: {
      parlayMinGames: "No trends available yet. Needs 3 games minimum.",
    },
    hundredPercentClub: {
      subtitle: "Props that hit in 100% of games",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Find value when starting lineups change. Included with",
        injuryImpact: "See how injuries impact teammates. Included with",
        opponentRank: "Exploit favourable defensive matchups. Included with",
        startingPitchers: "Target spots against vulnerable pitchers. Included with",
        weatherReport: "Use wind and weather to your advantage. Included with",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Loading markets...",
        loadError: "Unable to load markets.",
      },
    },
    sidebar: {
      improveExperience: "Improve your Linemate experience",
      getAccess: "GET ACCESS TO ADVANCED PLAYS & DEEPER INSIGHTS",
    },
  },
};
